import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ProcessedTicketDetail } from '@/types/knowledge';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface ErrorDetailSheetProps {
  isOpen: boolean;
  onClose: () => void;
  ticket: ProcessedTicketDetail | null;
}

export function ErrorDetailSheet({ isOpen, onClose, ticket }: ErrorDetailSheetProps) {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent className="w-full sm:max-w-xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Detalhes do Erro</SheetTitle>
          <SheetDescription>Informações da falha no processamento do ticket</SheetDescription>
        </SheetHeader>

        {ticket && (
          <Card className="mt-6">
            <CardHeader>
              <CardTitle className="text-base">Ticket {ticket.ticketId}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              <div>
                <p className="text-xs text-muted-foreground">Protocolo</p>
                <p className="font-mono text-sm">{ticket.protocol}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Mensagem</p>
                <pre className="text-xs whitespace-pre-wrap rounded-md bg-muted/40 p-3 overflow-x-auto">
                  {ticket.error || 'Sem mensagem de erro'}
                </pre>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Timestamp</p>
                <p className="text-sm">
                  {ticket.timestamp
                    ? format(new Date(ticket.timestamp), "dd/MM/yyyy 'as' HH:mm:ss", { locale: ptBR })
                    : 'Não informado'}
                </p>
              </div>
            </CardContent>
          </Card>
        )}
      </SheetContent>
    </Sheet>
  );
}
